import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse, ICatalog } from '../models';

export const getCatalogs = async (filters?: { page?: number; perPage?: number; sortBy?: string; sortDirection?: string; name?: string }): Promise<IResponse<ICatalog[]>> => {
  try {
    const { data } = await axios.get(`/api/catalogs`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getCatalogs failed');
    return Promise.reject(error);
  }
};
